var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AA587"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v63.539h512v-63.539 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 V321.84H0V385.379z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 204.1,
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 103.79
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,200.092 0,204.102 512,204.102 512,200.092 512,190.159 0,190.159  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,311.908 0,321.841 512,321.841 512,311.908 512,307.898 0,307.898  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M12.828,413.993l193.27-153.417c2.946-2.339,2.946-6.812,0-9.151L12.828,98.007 C4.959,105.03,0,115.244,0,126.621V385.38C0,396.756,4.959,406.97,12.828,413.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M81.814,198.577l12.905,38.695l40.789,0.317c2.281,0.018,3.226,2.929,1.391,4.284l-32.813,24.231 l12.303,38.891c0.687,2.175-1.788,3.974-3.644,2.647l-33.185-23.72l-33.185,23.72c-1.856,1.326-4.332-0.472-3.644-2.647 l12.303-38.891l-32.812-24.231c-1.835-1.355-0.889-4.266,1.391-4.284l40.789-0.317l12.905-38.695 C78.031,196.414,81.092,196.414,81.814,198.577z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M77.196,270.447l-3.19,3.21H47.328l7.281-26.717l2.975-1.487l-4.776,23.82 c-0.04,0.294,0.02,0.587,0.215,0.822c0.177,0.235,0.45,0.352,0.744,0.352L77.196,270.447L77.196,270.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M83.596,274.89c-1.155,0.861-2.564,1.351-4.032,1.351s-2.877-0.489-4.032-1.351l4.032-4.032 L83.596,274.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M111.801,273.657H85.123l-3.19-3.21h23.428c0.294,0,0.567-0.117,0.744-0.352 c0.195-0.235,0.255-0.529,0.215-0.822l-4.776-23.82l2.975,1.487L111.801,273.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M104.168,268.49H80.543v-24.369c3.954-3.347,14.386-1.057,18.809,0.313L104.168,268.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M78.585,244.121v24.369H54.961l4.815-24.055C64.2,243.064,74.632,240.775,78.585,244.121z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M114.033,274.381L106.301,246c-0.078-0.255-0.254-0.489-0.509-0.607l-5.167-2.583 c-0.02-0.02-0.04-0.02-0.078-0.02c-0.02,0-0.02-0.02-0.039-0.04c-0.627-0.215-14.934-4.874-20.943-0.313 c-6.009-4.561-20.317,0.098-20.943,0.313c-0.02,0.02-0.02,0.02-0.039,0.04c-0.04,0-0.058,0-0.078,0.02l-5.167,2.583 c-0.255,0.117-0.43,0.352-0.509,0.607l-7.732,28.381c-0.078,0.294-0.02,0.607,0.157,0.842c0.195,0.235,0.489,0.392,0.783,0.392 h27.402c1.624,1.624,3.817,2.583,6.126,2.583c2.31,0,4.502-0.959,6.126-2.583h27.402c0.294,0,0.587-0.157,0.783-0.392 C114.052,274.988,114.111,274.675,114.033,274.381z M80.543,244.121c3.954-3.347,14.386-1.057,18.809,0.313l4.815,24.055H80.543 C80.543,268.49,80.543,244.121,80.543,244.121z M59.776,244.435c4.424-1.37,14.856-3.66,18.809-0.313v24.369H54.961L59.776,244.435 z M47.328,273.657l7.281-26.717l2.975-1.487l-4.776,23.82c-0.04,0.294,0.02,0.587,0.215,0.822c0.177,0.235,0.45,0.352,0.744,0.352 h23.428l-3.19,3.21L47.328,273.657L47.328,273.657z M79.564,276.241c-1.468,0-2.877-0.489-4.032-1.351l4.032-4.032l4.032,4.032 C82.442,275.751,81.033,276.241,79.564,276.241z M85.123,273.657l-3.19-3.21h23.428c0.294,0,0.567-0.117,0.744-0.352 c0.195-0.235,0.255-0.529,0.215-0.822l-4.776-23.82l2.975,1.487l7.281,26.717L85.123,273.657L85.123,273.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M104.034,218.558c-0.998,0.695-2.35,0.576-3.211-0.285l-1.302-1.302v3.187l-7.967,7.967h-3.187 l-12.746,12.747h-3.187L47.926,265.38c-0.604,0.604-0.814,1.496-0.544,2.306l1.153,3.459l-4.78,4.78h-3.187l-9.743,9.743 c-0.778,0.778-0.778,2.04,0,2.819l6.43,6.43c0.928,0.928,2.45,0.87,3.304-0.127l14.35-17.272l1.593-4.78l3.187-3.187l6.374,9.56 l4.78-4.78l-5.099-7.648l1.27-1.27c1.235-1.235,1.235-3.236,0-4.471l-0.951-0.951l0.895-0.895 c6.801,5.828,14.967,7.335,22.742,4.002l-2.663-6.214c-6.424,2.753-11.67,0.45-15.319-2.549l13.464-13.464l-0.531-2.656 l3.718-3.718h3.187l23.901-23.901L104.034,218.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M56.501,215.378l-3.187,3.187c-0.879,0.879-0.879,2.306,0,3.187l0.531,0.531l-5.311,1.063 l-14.34,14.34l7.967,7.967l14.34-14.34l1.062-5.312l2.125,2.125l1.593-1.593l53,53l3.187-3.187l-53-53l1.593-1.593l-6.374-6.374 C58.808,214.498,57.382,214.498,56.501,215.378z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMz);
export default __webpack_public_path__ + "static/media/mz.83da770d777793c48010136f1fa6f34d.svg";
export { ForwardRef as ReactComponent };